import { Tooltip } from '@mui/material';
import { styled } from '@mui/material';
import TooltipTriggerText from 'components/TooltipTriggerText';

const TooltipWrapper = styled('span')({
  display: 'inline-block',
});

const AdHocAdjustmentTooltip: React.FC = () => {
  const content = (
    <>
      <p>Ad-hoc adjustments to this can be made in the following ways:</p>
      <br />
      <p>
        <strong>Discounts for advised investors:</strong> If all fees via a
        certain adviser have an initial fee discount or commission within the
        initial fee, this should be set on the adviser page before subscription
        applications are made by the adviser.
      </p>
      <br />
      <p>
        <strong>One-off fees/discounts:</strong> If there is an ad hoc
        adjustment to be made to the fee(s), this can be processed through the
        <i> One-off Fees / Discounts</i> function.
      </p>
    </>
  );

  return (
    <Tooltip wide title={content} arrow placement="right">
      <TooltipWrapper>
        <TooltipTriggerText
          content={
            <span>Making ad hoc and advised client fee adjustments</span>
          }
          icon
        />
      </TooltipWrapper>
    </Tooltip>
  );
};

export default AdHocAdjustmentTooltip;
